<template>
  <div>
    <!-- modal for edit -->
    <div class="modal modal-default fade" id="modal-show">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-success">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.preview')}}</h4>
          </div>
          <div class="modal-body">
            <exercise :bareBonesExercise="CelotnaNaloga" :showAnswer="true"></exercise>
          </div>
          <div class="modal-footer bg-success">
            <button class="btn btn-default pull-right" @click.prevent="toggleShowModal()">{{$t('pages.exerciseList.hide')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <div class="box">
      <section class="invoice">
        <!-- title row -->
        <div class="box-header">
          <div class="col-xs-1">
            <h2 class="page-header pull-right">
                <i v-if="!exam.isExam" class="fa fa-hourglass"></i>
                <i v-else class="fa fa-calendar"></i>
            </h2>
          </div>
          <div class="col-xs-3" v-bind:class="{ grayout: published }">
            <h3 class="page-header">
                <input type="text" name="title" v-model="exam.title" @input="changeTitle">
            </h3>
          </div>
          <label v-if="updatedExam && !published" class="pull-right text-green">{{$t('pages.exams.editExam.updated')}}</label>
          <label v-else-if="published" class="pull-right text-red">{{$t('pages.exams.editExam.unpublishWarning')}}</label>
          <!-- /.col -->
        </div>
        
        <!-- info row -->
        <div class="row invoice-info">
          <div v-bind:class="{ grayout: published }">
            <div class="col-sm-4">
              <label v-if = "!exam.liveTest">{{$t('pages.exams.editExam.selectType')}}: </label>
              <div style="margin-left: 1em;" class="btn-group" v-if="exam.isExam && !exam.liveTest">
                <button type="button" class="btn btn-sm btn-primary">{{$t('pages.exams.editExam.exam')}}</button>
                <button type="button" class="btn btn-sm" @click.prevent="changeType('quiz')">{{$t('pages.exams.editExam.quiz')}}</button>
                <button type="button" class="btn btn-sm" @click.prevent="changeType('test')">Test</button>
              </div>
              <div style="margin-left: 1em;" class="btn-group" v-if ="!exam.isExam && !exam.liveTest">
                <button type="button" class="btn btn-sm" @click.prevent="changeType('exam')">{{$t('pages.exams.editExam.exam')}}</button>
                <button type="button" class="btn btn-sm btn-primary">{{$t('pages.exams.editExam.quiz')}}</button>
                <button type="button" class="btn btn-sm" @click.prevent="changeType('test')">Test</button>
              </div>
              <div style="margin-left: 1em;" class="btn-group" v-if ="!exam.isExam && exam.liveTest">
                <button type="button" class="btn btn-sm btn-primary">TEST</button>
              </div>
            </div>
            <div class="col-sm-3">
              <!--<label>{{$t('pages.exams.editExam.displayResults')}}: </label>-->
              <div style="margin-left: 0em;" class="btn-group" v-if="exam.showResult">
                <button type="button" class="btn btn-sm btn-primary">{{$t('pages.exams.editExam.showResults')}}</button>
                <button type="button" class="btn btn-sm" @click.prevent="changeShowResult">{{$t('pages.exams.editExam.hideResults')}}</button>
              </div>
              <div style="margin-left: 0em;" class="btn-group" v-else>
                <button type="button" class="btn btn-sm" @click.prevent="changeShowResult">{{$t('pages.exams.editExam.showResults')}}</button>
                <button type="button" class="btn btn-sm btn-primary">{{$t('pages.exams.editExam.hideResults')}}</button>
              </div>
            </div>
            <div class="col-sm-5" v-if="!exam.liveTest">
              <label>{{$t('pages.exams.editExam.maxRetries')}}: </label>
              <div class="radio">
                <input type="radio" :checked="noLimit" @change="checkLimit(true)">
                <span for="one">{{$t('pages.exams.editExam.noLimit')}}</span>
              </div>
              <div class="radio">
                <input type="radio" :checked="!noLimit" @change="checkLimit(false)">
                <input v-bind:class="{ grayout: noLimit }" type="number" name="retries" v-model="exam.maxRetries" @input="changeRetries" min=1>
              </div>
            </div>
            <div class="col-sm-7" v-if="!exam.liveTest">
              <label>{{$t('pages.exams.editExam.oneAtATime')}}: </label>
              <div class="radio">
                <input type="radio" :checked="oneAtATime" @change="setOneAtATime(true)">
                <span for="one">{{$t('pages.exams.editExam.enabled')}}</span>
              </div>
              <div class="radio">
                <input type="radio" :checked="!oneAtATime" @change="setOneAtATime(false)">
                <span for="one">{{$t('pages.exams.editExam.disabled')}}</span>
              </div>
            </div>
            <div class="col-sm-5" v-if="!exam.liveTest">
              <label>{{$t('pages.exams.editExam.shuffle')}}: </label>
              <div class="radio">
                <input type="radio" :checked="shuffle" @change="setShuffle(true)">
                <span for="one">{{$t('pages.exams.editExam.enabled')}}</span>
              </div>
              <div class="radio">
                <input type="radio" :checked="!shuffle" @change="setShuffle(false)">
                <span for="one">{{$t('pages.exams.editExam.disabled')}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Table row -->
        
      <!-- EXERCISES LIST (QUIZ & EXAM) -->
        <div class="row" v-if ="!exam.liveTest">
          <h3 class="page-header">{{$t('pages.exams.editExam.exercises')}}</h3>
          <div class="row margin">
            <div class="pull-left">
              <button v-bind:class="{ grayout: published }" type="button" class="btn btn-default" @click.prevent="toggleExercisesModal()">
                <i class="fa fa-plus"></i>
              </button>
              <button v-bind:class="{ grayout: published }" type="button" class="btn btn-default" @click.prevent="selectSubgroups()">
                <i class="fa fa-bar-chart"></i> 
              </button>
              <button class="btn btn-default" data-toggle="modal" data-target="#modal-updateExam">{{$t('pages.exams.editExam.refreshExercises')}}</button>
              <button class="btn btn-default" @click.prevent="toggleCollapseParametric">{{collapseParametric ? $t('pages.exams.editExam.expandParametric') : $t('pages.exams.editExam.collapseParametric')}}</button>

            </div>
            <label v-if="updated && !published" class="pull-right text-green">{{$t('pages.exams.editExam.updated')}}</label>
          </div>
          <div class="col-xs-12">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{$t('pages.exams.editExam.tableData')}}</th>
                  <th>{{$t('pages.exams.editExam.tableTags')}}</th>
                  <th>{{$t('pages.exams.editExam.tablePoints')}}</th>
                  <th v-if="oneAtATime">{{$t('pages.exams.editExam.tableTime')}}</th>
                </tr>
              </thead>
            <draggable v-if="!published" :list="this.combinedExamExercises" :element="'tbody'">
                <tr v-for="(ex,ix) in this.combinedExamExercises" :key="ex.exercise.data.id" name="content" rowspan=3>
                  <td style="width: 3em">{{ix + 1}}</td>
                  <td href="#" style="width: 8em" v-if="ex.exercise.data.id">
                    <a href="#" @click.prevent="openModal(ex)">{{ex.exercise.data.id}}</a>
                    <a v-if="collapseParametric && ex.parent" href="#" @click.prevent="showAllExerciseVersions(ex)">
                      <div class="badge bg-green">({{getAllExerciseVersions(ex).length}} {{$t('pages.exams.editExam.versions')}})</div>
                    </a>
                    <a v-if="!collapseParametric && ex.parent" href="#" @click.prevent="toggleCollapseParametric">
                      <div class="badge bg-green">({{$t('pages.exams.editExam.collapseParametric')}})</div>
                    </a>
                  </td>
                  <td name="tags">
                    <span v-for="tag in ex.exercise.data.tags">
                      <div class="badge bg-blue">{{tag}}</div>
                    </span>
                  </td>
                  <td style="width: 35em">
                    <div>
                      <div>
                        <div class="row" v-for="(set,ix1,ix2) in ex.scoringSettings" :key="ix1" style="margin-right: 1em; margin-bottom: 0.125em; border: 0.5px solid; border-radius: 5px; border-color: rgba(0,0,0,0.2)">
                          <form>
                          <span style="width: 10em; margin-right: 2em; margin-left: 1em;">
                            {{$t('pages.exams.editExam.question')}} {{ix2+1}}
                          </span>
                          <span style="margin-right: 2em;">
                              <i class="fa fa-plus-circle" style="margin-right: 0.25em; color: #3c8dbc"></i>
                              <input type="number" name="points3" min=0 v-model="set.posPoints" @input="changePoints(ex, set, false, ix1)">
                          </span>
                          <span v-bind:class="{ grayout: !set.allowNegativePointsSum }" style="margin-right: 1em;">
                              <i class="fa fa-minus-circle" style="margin-right: 0.25em; color: #3c8dbc"></i>
                              <input min="0" step="1" type="number" name="points3" v-model="set.negPoints" @input="changePoints(ex, set, false, ix1)">
                          </span>
                          <span width="130">
                            <a class="btn btn-lg allow">
                              <i v-if="!set.allowNegativePointsSum" class="fa fa-minus-square-o" @click.prevent="changePoints(ex, set, true, ix1)"></i>
                              <i v-else class="fa fa-check-square-o" @click.prevent="changePoints(ex, set, true, ix1)"></i>
                            </a>
                            <span class="small" v-show="!set.allowNegativePointsSum">{{$t('pages.exams.editExam.notAllowed')}}</span>
                            <span class="small" v-show="set.allowNegativePointsSum">{{$t('pages.exams.editExam.allowed')}}</span>
                          </span>
                          </form>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td href="#" style="width: 3em" v-if="oneAtATime">
                    <input type="number" v-model="ex.exerciseSeconds" @input="changeTime(ex)" min=1>
                  </td>
                  <td>
                  <a href="#" @click.prevent="removeRowExercise(ex)" class="pull-right btn-sm btn-danger">
                    <i class="fa fa-trash"></i>
                  </a>
                  </td>
                </tr>
            </draggable>
           <tbody v-else-if ="published && !exam.liveTest" v-bind:class="{ grayout: published }">
               <tr v-for="(ex,ix) in this.combinedExamExercises" :key="ex.exercise.data.id" name="content">
                  <td style="width: 3em">{{ix + 1}}</td>
                  <td style="width: 8em" v-if="ex.exercise.data.id"><a href="#" @click.prevent="openModal(ex)">{{ex.exercise.data.id}}</a></td>
                  <td name="tags">
                    <span v-for="tag in ex.exercise.data.tags">
                      <div class="badge bg-blue">{{tag}}</div>
                    </span>
                  </td>
                  <td style="width: 35em">
                    <div>
                      <div>
                        <div class="row" v-for="(set,ix1,ix2) in ex.scoringSettings" :key="ix1" style="margin-right: 1em; margin-bottom: 0.125em; border: 0.5px solid; border-radius: 5px; border-color: rgba(0,0,0,0.2)">
                          <form>
                          <span style="width: 10em; margin-right: 2em; margin-left: 1em;">
                            {{$t('pages.exams.editExam.question')}} {{ix2+1}}
                          </span>
                          <span style="margin-right: 2em;">
                              <i class="fa fa-plus-circle" style="margin-right: 0.25em; color: #3c8dbc"></i>
                              <input type="number" name="points3" min=0 v-model="set.posPoints" @input="changePoints(ex, set, false)">
                          </span>
                          <span v-bind:class="{ grayout: !set.allowNegativePointsSum }" style="margin-right: 1em;">
                              <i class="fa fa-minus-circle" style="margin-right: 0.25em; color: #3c8dbc"></i>
                              <input min="0" step="1" type="number" name="points3" v-model="set.negPoints" @input="changePoints(ex, set, false)">
                          </span>
                          <span width="130">
                            <a class="btn btn-lg allow">
                              <i v-if="!set.allowNegativePointsSum" class="fa fa-minus-square-o" @click.prevent="changePoints(ex, set, true)"></i>
                              <i v-else class="fa fa-check-square-o" @click.prevent="changePoints(ex, set, true)"></i>
                            </a>
                            <span class="small" v-show="!set.allowNegativePointsSum">{{$t('pages.exams.editExam.notAllowed')}}</span>
                            <span class="small" v-show="set.allowNegativePointsSum">{{$t('pages.exams.editExam.allowed')}}</span>
                          </span>
                          </form>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <a  @click.prevent="removeRowExercise(ex)" class="pull-right btn-sm btn-danger">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>

          </table>
          </div>
        </div>
        <!-- /EXERCISES LIST (QUIZ & EXAM) -->

      <!-- EXERCISES LIST (LIVE TEST) *********** MUST FIX -->
      <div class="row" v-if = "exam.liveTest">
        <table class = 'exerciseGroupsList'>
          <tr class = 'exerciseGroupsContainer' v-for="(name, index) in ['A', 'B', 'C', 'D']" :key="name">

            <h4 class = 'exerciseGroupsTitle'>GROUP {{name}}</h4>
            <button type="button" class="exerciseGroupsAddButton" @click.prevent="selectGroup(name) + toggleExercisesModal()">
              <i class="fa fa-plus"></i>
            </button>

            <span style="position: relative;">
              <button type="button" class="exerciseGroupsAddButton dropdown-toggle" data-toggle="dropdown" style="margin-left: 1ex;">
                <i class="fa fa-copy"></i> {{$t('pages.exams.editExam.copyExercises')}}
              </button>
              <ul class="dropdown-menu">
                <li v-for="(n, i) in ['A', 'B', 'C', 'D']" :key="name + '.' + n" v-if="n !== name"><a @click="copyExercises(name, i)">{{$t('pages.exams.editExam.fromGroup')}} {{n}}</a></li>
              </ul>
            </span>

            <button type="button" class="exerciseGroupsAddButton" @click.prevent="selectGroup(name); selectSubgroups()" style="margin-left: 1ex;">
              <i class="fa fa-bar-chart"></i> {{$t('pages.exams.editExam.ratingExercises')}}
            </button>

            <div class="row margin">
              <div class="col-xs-12">
                <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{{$t('pages.exams.editExam.tableData')}}</th>
                    <th>{{$t('pages.exams.editExam.tableTags')}}</th>
                    <th>{{$t('pages.exams.editExam.tablePoints')}}</th>
                  </tr>
                </thead>

                <draggable :list="examExercisesByGroup[index]" :element="'tbody'">

                <tr v-for="(ex,ix) in examExercisesByGroup[index]" :key="index + '.' + ix" name="content" rowspan=3>

                    <td style="width: 3em">{{ix + 1}}</td>

                    <td href="#" style="width: 8em" v-if="ex.exercise.data.id">
                      <a href="#" @click.prevent="openModal(ex)">{{ex.exercise.data.id}}</a>
                    </td>

                    <td name="tags">
                      <span v-for="tag in ex.exercise.data.tags" :key="index + '.' + ix + '.' + tag">
                        <div class="badge bg-blue">{{tag}}</div>
                      </span>
                    </td>

                    <td style="width: 35em">
                    <div>
                      <div>
                        <div class="row" v-for="(set,ix1,ix2) in ex.scoringSettings" :key="index + '-' + ix1" style="margin-right: 1em; margin-bottom: 0.125em; border: 0.5px solid; border-radius: 5px; border-color: rgba(0,0,0,0.2)">
                          <form>
                          <span style="width: 10em; margin-right: 2em; margin-left: 1em;">
                            {{$t('pages.exams.editExam.question')}} {{ix2+1}}
                          </span>
                          <span style="margin-right: 2em;">
                              <i class="fa fa-plus-circle" style="margin-right: 0.25em; color: #3c8dbc"></i>
                              <input type="number" name="points3" min=0 v-model="set.posPoints" @input="changePoints(ex, set, false)">
                          </span>
                          <span v-bind:class="{ grayout: !set.allowNegativePointsSum }" style="margin-right: 1em;">
                              <i class="fa fa-minus-circle" style="margin-right: 0.25em; color: #3c8dbc"></i>
                              <input min="0" step="1" type="number" name="points3" v-model="set.negPoints" @input="changePoints(ex, set, false)">
                          </span>
                          <span width="130">
                            <a class="btn btn-lg allow">
                              <i v-if="!set.allowNegativePointsSum" class="fa fa-minus-square-o" @click.prevent="changePoints(ex, set, true)"></i>
                              <i v-else class="fa fa-check-square-o" @click.prevent="changePoints(ex, set, true)"></i>
                            </a>
                            <span class="small" v-show="!set.allowNegativePointsSum">{{$t('pages.exams.editExam.notAllowed')}}</span>
                            <span class="small" v-show="set.allowNegativePointsSum">{{$t('pages.exams.editExam.allowed')}}</span>
                          </span>
                          </form>
                        </div>
                      </div>
                    </div>
                  </td>

                    <td>
                      <a href="#" @click.prevent="removeExerciseGroup(ex)" class="pull-right btn-sm btn-danger">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>

                    </tr>
                  </draggable>
                </table>
              </div> 
            </div>
          </tr>
        </table>
      </div>
      <!-- /EXERCISES LIST (LIVE TEST) -->

        <div class="row">
          <h3 class="page-header">{{$t('pages.exams.editExam.classExams')}}</h3>
          <div class="row margin">
            <div class="btn-group over-border">
              <button v-bind:class="{ grayout: published }" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                <i class="fa fa-plus"></i>
              </button>
              <ul class="dropdown-menu" style="position:absolute;" role="menu">
                <li v-for="cl2 in classes">
                  <a href="#" @click.prevent="createClassExam(cl2)">{{cl2.name}}</a>
                </li>
              </ul>
            </div>
            <label v-if="updated2 && !published" class="pull-right text-green">{{$t('pages.exams.editExam.updated')}}</label>
          </div>
          <div class="col-xs-12 table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>{{$t('pages.exams.editExam.tableClass')}}</th>
                  <th>{{$t('pages.exams.editExam.tablePass')}}</th>
                  <th>{{$t('pages.exams.editExam.tableDateTime')}}</th>
                  <th>{{$t('pages.exams.editExam.tableDuration')}}</th>
                  <th v-if = 'exam.isExam == false && exam.liveTest'>{{$t('pages.exams.editExam.classRoom')}}</th>
                </tr>
              </thead>
              <tbody >
                <tr v-for="(cl,index) in this.classExams">
                  <td v-bind:class="{ grayout: published }">
                    {{cl.class.name}}
                  </td>
                  <td v-bind:class="{ grayout: published }">
                    <button class="btn btn-sm btn-default" name="btn-pass" v-if="cl.passwordRequired" @click.prevent="changePassModal(cl)">********</button>
                    <button class="btn btn-sm btn-default" name="btn-pass" v-else @click.prevent="changePassModal(cl)">{{$t('pages.exams.editExam.passwordNotSet')}}</button>
                  </td>
                  <td class="date-range" v-bind:class="{ grayout: published }">
                    <div>
                      <date-range-picker class="picker" v-model="dateRange" :startDate="cl.startsAt" :endDate="cl.finishesAt" :nameOfPicker="cl.id">
                      </date-range-picker>
                    </div>
                  </td>
                  <td class="duration" v-bind:class="{ grayout: published }">
                    <div class="input-group">
                      <input type="number" name="points2" min=0 step=1 v-model="cl.duration" @input="changeDuration(cl, index)">
                      <select v-model="selected[index]" @change="changeDuration(cl,index)">
                        <option v-bind:selected="3">{{$t('pages.exams.editExam.timeMinutes')}}</option>
                        <option v-bind:selected="4">{{$t('pages.exams.editExam.timeHours')}}</option>
                        <option v-bind:selected="5">{{$t('pages.exams.editExam.timeDays')}}</option>
                      </select>
                    </div>
                  </td>
                  <td v-if ='exam.isExam == false && exam.liveTest' v-bind:class="{ grayout: published }"> 
                    <select @change='updateClassroom(cl)' class='classroomDropdown' name='classroomSelect' v-model='cl.classroom'>
                      <option v-for='classroom in availableClassrooms' :key='classroom.id' :value='classroom.id'>{{JSON.parse(classroom.classroomInfo).name}}</option>
                    </select>
                  </td>
                  <td class="pull-right">
                    <div class="btn-group">
                      <button v-if="!cl.publishedAt" @click.prevent="publish(cl, true)" class="btn btn-sm btn-primary">{{$t('pages.exams.editExam.publish')}}</button>
                    </div>
                    <button v-bind:class="{ grayout: published }" v-if="!cl.publishedAt" class="btn btn-sm btn-danger" @click.prevent="removeRowClass(cl)">
                        <i class="fa fa-trash"></i>
                    </button>
                    <button v-else @click.prevent="publish(cl, false)" class="btn btn-sm btn-default bg-primary">{{$t('pages.exams.editExam.unpublish')}}</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row" style="border-top: 0.1em double #3c8dbc">
          <div class="pull-left margin">
            <button class="btn btn-danger" @click.prevent="toggleDeleteExam">
              <i class="fa fa-trash"></i>
            </button>
          </div>
          <div class="pull-right margin">
            <button class="btn btn-primary btn-lg" @click.prevent="$router.go(-1)">{{$t('pages.exams.editExam.save')}}</button>
          </div>
        </div>
        <!-- /.row -->
      </section>
    </div>
    <div class="modal modal-default fade" id="modal-edit">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.editExam.modals.changePassword')}}</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <input class="form-control" v-model="newPass"></input>
              <small>{{$t('pages.exams.editExam.modals.noPassword')}}</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary" @click.prevent="changePass()">{{$t('pages.exams.editExam.modals.update')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <!-- EXERCISES SEARCH - QUIZ & EXAM -->
    <div class="modal modal-default" id="modal-exercises" data-target="#modal-exercises">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.editExam.modals.searchExercises')}}</h4>
          </div>
          <div class="modal-body">
            <exercises-search></exercises-search>
          </div>
          <div class="modal-footer bg-primary">
            <button class="btn btn-default pull-left" @click.prevent="toggleExercisesModal()">{{$t('pages.exams.editExam.modals.cancel')}}</button>
            <button v-if="selectedExercises.length > 0" class="btn btn-default" @click.prevent="addExercisesBulk()">{{$t('pages.exams.editExam.modals.add')}}</button>
            <button v-else class="btn btn-default disabled">{{$t('pages.exams.editExam.modals.add')}}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- /EXERCISES SEARCH - QUIZ & EXAM -->
  
    <div class="modal modal-default fade" id="modal-deleteExam">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.editExam.modals.deleteTitle')}}</h4>
          </div>
          <div class="modal-body">
            <button class="btn btn-danger pull-right" @click.prevent="deleteExam">{{$t('pages.exams.editExam.modals.deleteConfirm')}}</button>
            <button class="btn btn-primary pull-left" @click.prevent="toggleDeleteExam">{{$t('pages.exams.editExam.modals.deleteCancel')}}</button>
            <div class="clearfix"></div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    
    <div class="modal modal-default fade" id="modal-updateExam">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.editExam.modals.updateTitle')}}</h4>
          </div>
          <div class="modal-body">
            <p>{{$t('pages.exams.editExam.modals.updateBody')}}</p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-danger pull-right" @click.prevent="fetchLatest" v-bind:class="{ grayout: classExams.length > 0 }">{{$t('pages.exams.editExam.modals.confirmFetchLatest')}}</button>
            <button class="btn btn-primary pull-left" data-dismiss="modal">{{$t('pages.exams.editExam.modals.deleteCancel')}}</button>
            <div class="clearfix"></div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    
    <div class="modal modal-default fade" id="modal-exercise-versions">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.exams.editExam.exerciseVersions')}}</h4>
          </div>
          <div class="modal-body">

            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{$t('pages.exams.editExam.tableData')}}</th>
                  <th>{{$t('pages.exams.editExam.tablePoints')}}</th>
                </tr>
              </thead>
                <tr v-for="(ex,ix) in this.parametricExerciseVersions" :key="ex.exercise.data.id + '-parametric'" rowspan=3>
                  <td style="width: 3em">{{ix + 1}}</td>
                  <td href="#" style="width: 8em" v-if="ex.exercise.data.id">
                    <a href="#" data-dismiss="modal" @click.prevent="openModal(ex)">{{ex.exercise.data.id}}</a>
                  </td>
                  <td style="width: 35em">
                    <div>
                      <div>
                        <div class="row" v-for="(set,ix1,ix2) in ex.scoringSettings" :key="ix1" style="margin-right: 1em; margin-bottom: 0.125em; border: 0.5px solid; border-radius: 5px; border-color: rgba(0,0,0,0.2)">
                          <form>
                          <span style="width: 10em; margin-right: 2em; margin-left: 1em;">
                            {{$t('pages.exams.editExam.question')}} {{ix2+1}}
                          </span>
                          <span style="margin-right: 2em;">
                              <i class="fa fa-plus-circle" style="margin-right: 0.25em; color: #3c8dbc"></i>
                              <input type="number" name="points3" min=0 v-model="set.posPoints" @input="changePoints(ex, set, false, ix1, true)">
                          </span>
                          <span v-bind:class="{ grayout: !set.allowNegativePointsSum }" style="margin-right: 1em;">
                              <i class="fa fa-minus-circle" style="margin-right: 0.25em; color: #3c8dbc"></i>
                              <input min="0" step="1" type="number" name="points3" v-model="set.negPoints" @input="changePoints(ex, set, false, ix1, true)">
                          </span>
                          <span width="130">
                            <a class="btn btn-lg allow">
                              <i v-if="!set.allowNegativePointsSum" class="fa fa-minus-square-o" @click.prevent="changePoints(ex, set, true, ix1, true)"></i>
                              <i v-else class="fa fa-check-square-o" @click.prevent="changePoints(ex, set, true, ix1, true)"></i>
                            </a>
                            <span class="small" v-show="!set.allowNegativePointsSum">{{$t('pages.exams.editExam.notAllowed')}}</span>
                            <span class="small" v-show="set.allowNegativePointsSum">{{$t('pages.exams.editExam.allowed')}}</span>
                          </span>
                          </form>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
            </table>

          </div>
          <div class="modal-footer">
            <button class="btn btn-primary pull-right" data-dismiss="modal" >{{$t('pages.exams.editExam.modals.cancel')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal modal-default fade" :id="'selectSubgroupsModal'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.subgroups.selectSubgroups')}}</h4>
          </div>
          <div class="modal-body">
            <span style="width: 100%; text-align: center;" v-if="loadingSubgroups">
              <pulse-loader :color="spinnerColor" :size="spinnerSize"></pulse-loader>
            </span>
            <div class="form-group">
              <div v-for="podskupina in drevoPodskupin">
                <div :style="'margin-left: ' + (2*podskupina.nivo) + 'em'">
                  <input v-if="podskupina.list" type="checkbox" :id="podskupina.id" :value="podskupina.id" v-model="izbranePodskupine">
                  <label :for="podskupina.id">{{ podskupina.name | pickTranslation }}</label>
                  <span v-if="!podskupina.list" @click.prevent="selectAllSbgroupsInTree(podskupina.id, true)" class="text-light-blue pointer">({{$t('pages.subgroups.addAll')}})</span>
                  <span v-if="!podskupina.list" @click.prevent="selectAllSbgroupsInTree(podskupina.id, false)" class="text-light-blue pointer">({{$t('pages.subgroups.removeAll')}})</span>
                </div>
              </div>
            </div>
            <!--Izbira trajanja-->
            <div class="form-group">
              <label>{{$t('pages.subgroups.selectDuration')}}</label>
              <select class="form-control" v-model="izbranoTrajanje">
                <option value="20">20 min</option>
                <option value="30">30 min</option>
                <option value="45">45 min</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary pull-right" data-dismiss="modal" @click.prevent="addRatingExercises()">{{$t('pages.exams.editExam.addExercises')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Rest from './../../../services/rest'
  import DateRangePicker from '@/components/reusables/DateRangePicker.vue'
  import draggable from 'vuedraggable'
  import vSelect from 'vue-select'
  import ExercisesSearch from '@/components/admin/Library.vue'
  import Exercise from '@/components/exercises/Exercise.vue'
  import { mapState } from 'vuex'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  let moment = require('moment')

  export default {
    props: {
      gid: '',
      yid: '',
      examId: ''
    },
    data () {
      return {
        exam: Object,
        examExercises: [],
        combinedExamExercises: [],
        examExercisesByGroup: [ [], [], [], [] ],
        examExercisesByGroupID: [ [], [], [], [] ],
        classExams: [],
        selected: [],
        dateRange: null,
        searchExercises: '',
        classes: [],
        Search: 0,
        Search2: 0,
        newTitle: '',
        newType: '',
        newShowResult: '',
        newRetries: '',
        editExercise: [],
        newPlus: false,
        newMinus: false,
        newAllow: false,
        updated: false,
        updatedExam: false,
        conToMinutes: [],
        editClassExam: Object,
        newPass: '',
        newDuration: false,
        newDuration2: 0,
        published: false,
        updated2: false,
        noLimit: false,
        liveTestGroupCount: 0,
        loadingSubgroups: false,
        drevoPodskupin: [],
        izbranoTrajanje: 20,
        izbranePodskupine: [],
        spinnerColor: '#3c8dbc',
        spinnerSize: '30px',
        oneAtATime: false,
        newOneAtATime: false,
        shuffle: false,
        newShuffle: false,
        collapseParametric: true,
        parametricExerciseVersions: []
      }
    },
    components: {
      'v-select': vSelect,
      'date-range-picker': DateRangePicker,
      draggable,
      'exercises-search': ExercisesSearch,
      'exercise': Exercise,
      'pulse-loader': PulseLoader
    },
    computed: {
      ...mapState({
        exercises: state => state.exercises.allExercises,
        selectedExercises: state => state.exercises.selectedExercises,
        picker: state => state.exam.picker,
        CelotnaNaloga: state => state.exerciseForModal
      })
    },
    watch: {
      combinedExamExercises (newValue) {
        let newExamExercises = []
        for (let i = 0; i < newValue.length; i++) {
          let allExercisesWithThisParent = this.getAllExerciseVersions(newValue[i])
          newExamExercises = newExamExercises.concat(allExercisesWithThisParent)
        }
        this.examExercises = newExamExercises
      },
      examExercises (val) {
        this.updateCombinedExercises()
        let putdata = {
          examExerciseIds: val.map(ex => ex.id)
        }
        return Rest.request('PUT', '/exams/' + this.exam.id + '/exercises/reorder', putdata).then((data) => {
        }).catch((err) => {
          console.log(err)
        })
      },
      dateRange (value) { // Action on apply picker
        let putdata = {
          startsAt: value.start,
          finishesAt: value.end
        }
        this.editClassExam.id = this.picker
        let classExamIndex = this.classExams.findIndex((classExam) => classExam.id === this.editClassExam.id)
        this.classExams[classExamIndex].startsAt = putdata.startsAt
        this.classExams[classExamIndex].finishesAt = putdata.finishesAt
        this.updateClassExam(putdata)
      }
    },
    methods: {
      showAllExerciseVersions (exercise) {
        this.parametricExerciseVersions = this.getAllExerciseVersions(exercise)
        window.jQuery('#modal-exercise-versions').modal('toggle')
      },
      toggleCollapseParametric () {
        this.collapseParametric = !this.collapseParametric
        this.updateCombinedExercises()
      },
      updateCombinedExercises () {
        let filteredExercises = []
        for (let i = 0; i < this.examExercises.length; i++) {
          if (this.collapseParametric && this.examExercises[i].parent) {
            if (i === 0 || this.examExercises[i].parent !== this.examExercises[i - 1].parent) {
              filteredExercises.push(this.examExercises[i])
            }
          } else {
            filteredExercises.push(this.examExercises[i])
          }
        }
        if (this.combinedExamExercises.length !== filteredExercises.length) {
          this.combinedExamExercises = filteredExercises
        }
      },
      getAllExerciseVersions (parentEx) {
        if (this.collapseParametric && parentEx.parent) {
          return this.examExercises.filter(ex => { return ex.parent === parentEx.parent })
        } else {
          return this.examExercises.filter(ex => { return ex.id === parentEx.id })
        }
      },
      fetchLatest () {
        this.$snotify.async('', '', () => new Promise((resolve, reject) =>
           Rest.request('GET', '/exams/' + this.examId + '/refreshExerciseVersions').then((data) => {
             resolve({
               title: this.$t('pages.exams.editExam.updated'),
               config: {
                 closeOnClick: true,
                 timeout: 2000
               }
             })
           }).catch((err) => {
             reject(err)
           })
        ))
      },
      changeTime (exercise) {
        this.editExercise = this.editExercise.filter(ex => ex.id !== exercise.id)
        exercise.exerciseSeconds = Number(exercise.exerciseSeconds)
        this.editExercise.push(exercise)
        if (exercise.parent) {
          // if exercise is parametric update all children
          let children = this.getAllExerciseVersions(exercise)
          children.forEach(ex => {
            if (ex.id !== exercise.id) {
              ex.exerciseSeconds = exercise.exerciseSeconds
              this.editExercise = this.editExercise.filter(ex2 => ex2.id !== ex.id)
              this.editExercise.push(ex)
            }
          })
        }
        this.newAllow = !this.newAllow
      },
      // created method
      setOneAtATime (value) {
        this.oneAtATime = value
        this.newOneAtATime = value
      },
      setShuffle (value) {
        this.shuffle = value
        this.newShuffle = value
      },
      getExam () {
        let en = this
        return Rest.request('GET', '/exams/' + this.examId).then(function (data) {
          en.exam = data
        }).catch(function (err) {
          console.log(err)
        })
      },
      toggleDeleteExam () {
        window.jQuery('#modal-deleteExam').modal('toggle')
      },
      deleteExam () {
        window.jQuery('#modal-deleteExam').modal('toggle')
        Rest.request('DELETE', '/exams/' + this.examId).then((data) => {
          this.$router.go(-1)
        }).catch((err) => {
          console.log(err)
        })
      },
      getClasses () {
        return Rest.request('GET', '/years/' + this.yid + '/classes').then(data => { // TODO spremeni
          this.classes = data.classes
        }).catch(function (err) {
          console.log(err)
        })
      },
      // time methods
      formatTime () {
        for (var i = 0; i < this.classExams.length; i++) {
          if (this.classExams[i].duration > 14080000) {
            this.classExams[i].duration = this.classExams[i].duration / 3600000
            this.classExams[i].duration = Number((this.classExams[i].duration).toFixed(1))
            this.selected[i] = this.$t('pages.exams.editExam.timeHours')
          } else {
            this.classExams[i].duration = this.classExams[i].duration / 60000
            this.classExams[i].duration = Number((this.classExams[i].duration).toFixed(1))
            this.selected[i] = this.$t('pages.exams.editExam.timeMinutes')
          }
        }
      },
      setPublished () {
        for (var i = 0; i < this.classExams.length; i++) {
          if (this.classExams[i].publishedAt != null) {
            this.published = true
            return
          }
        }
        this.published = false
      },
      // search exercises before adding new
      getOptions (search, loading) {
        this.searchExercises = search
        loading(false)
      },
      // updating exam setting
      changeTitle () {
        this.newTitle = this.exam.title
      },
      changeType (type) {
        if (type === 'exam') {
          this.exam.isExam = true
          this.newType = 'exam'
        } else if (type === 'quiz') {
          this.exam.isExam = false
          this.newType = 'quiz'
        } else {
          this.liveTest = confirm('Ali želite narediti test?')
          if (this.liveTest) {
            this.exam.isExam = false
            this.newType = 'test'
            this.newRetries = 1
            this.liveTest = true
            this.getClassrooms()
          }
        }
      },
      getClassrooms () {
        this.availableClassrooms = []
        return Rest.request('GET', '/classrooms/getClassrooms').then(data => {
          for (let i = 0; i < data.length; i++) {
            this.availableClassrooms.push(data[i])
          }
        }).catch(function (err) {
          console.log(err)
        })
      },
      changeShowResult () {
        this.exam.showResult = !this.exam.showResult
        this.newShowResult = this.exam.showResult
      },
      changeRetries () {
        this.newRetries = this.exam.maxRetries
      },
      updateExam (postdata) {
        return Rest.request('PUT', '/exams/' + this.exam.id, postdata).then((data) => {
          this.updatedExam = true
        }).catch((err) => {
          console.log(err)
        })
      },
      // exam exercise methods
      changePoints (exercise, question, allow, questionGUID, editIndividual) {
        this.editExercise = this.editExercise.filter(ex => ex.id !== exercise.id)
        this.editExercise.push(exercise)
        if (allow) {
          question.allowNegativePointsSum = !question.allowNegativePointsSum
        } else {
          question.posPoints = Number(question.posPoints)
          question.negPoints = Number(question.negPoints)
        }
        if (!editIndividual && exercise.parent) {
          // if exercise is parametric update all children
          let allQuestions = exercise.exercise.data.questions
          let questionIndex = allQuestions.findIndex(el => el.guid === questionGUID)
          let children = this.getAllExerciseVersions(exercise)
          children.forEach(ex => {
            if (ex.id !== exercise.id) {
              let guidInThisEx = ex.exercise.data.questions[questionIndex].guid
              ex.scoringSettings[guidInThisEx].posPoints = Number(question.posPoints)
              ex.scoringSettings[guidInThisEx].negPoints = Number(question.negPoints)
              ex.scoringSettings[guidInThisEx].allowNegativePointsSum = question.allowNegativePointsSum
              this.editExercise = this.editExercise.filter(ex2 => ex2.id !== ex.id)
              this.editExercise.push(ex)
            }
          })
        }
        this.newAllow = !this.newAllow
      },
      addExerciseButton () {
        this.Search = !this.Search
      },
      addRowExercise (exercise) {
        var exe = {exerciseVersionId: exercise.latestExerciseVersionId, order: this.examExercises.length + 1, exercise: {data: {id: exercise.data.id, tags: exercise.data.tags}}, posPoints: 0, negPoints: 0, allowNegativePointsSum: false}
        var postdata = {
          exerciseVersionId: exe.exerciseVersionId
        }
        return Rest.request('POST', '/exams/' + this.exam.id + '/exercises', postdata).then((data) => {
          this.Search = !this.Search
          // this.examExercises.push(exe)
          this.$nextTick(function () {
            this.getExam().then((data) => {
              this.examExercises = this.exam.examExercises
            })
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      addExercisesBulk () {
        if (this.exam.liveTest) {
          return this.addExercisesGroup()
        } else {
          var postdata = {
            exerciseVersionIds: this.selectedExercises
          }
          return Rest.request('POST', '/exams/' + this.exam.id + '/exercises/bulk', postdata).then((data) => {
            window.jQuery('#modal-exercises').modal('toggle')
            this.$store.commit('updateSelectedExercises', [])
            this.$nextTick(() => {
              this.getExam().then((examdata) => {
                this.examExercises = this.exam.examExercises
                this.setDefaultScoringSettings(data.map(e => e.exerciseVersionId))
              })
            })
          }).catch((err) => {
            console.log(err)
          })
        }
      },
      addExercisesGroup () {
        var postdata = {
          exerciseVersionIds: this.selectedExercises,
          group: this.selectedGroup
        }
        return Rest.request('POST', '/exams/' + this.exam.id + '/exercises/group', postdata).then((data) => {
          window.jQuery('#modal-exercises').modal('toggle')
          this.$nextTick(function () {
            this.getExam().then((data) => {
              this.$store.commit('updateSelectedExercises', [])
              this.examExercises = this.exam.examExercises
              this.selectedGroup = 'NONE'
              this.reorderExercisesByGroup()
              this.setDefaultScoringSettings(postdata.exerciseVersionIds)
            })
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      copyExercises (name, i) {
        let exercisesToAdd = []

        for (let j = 0; j < this.examExercisesByGroup[i].length; j++) {
          exercisesToAdd.push(this.examExercisesByGroup[i][j].exerciseVersionId)
        }

        for (let j = 0; j < exercisesToAdd.length; j++) {
          let randomIndex = Math.floor(Math.random() * exercisesToAdd.length)
          let temporaryValue = exercisesToAdd[j]
          exercisesToAdd[j] = exercisesToAdd[randomIndex]
          exercisesToAdd[randomIndex] = temporaryValue
        }

        var postdata = {
          exerciseVersionIds: exercisesToAdd,
          group: name
        }
        return Rest.request('POST', '/exams/' + this.exam.id + '/exercises/group', postdata).then((data) => {
          // window.jQuery('#modal-exercises').modal('toggle')
          this.$nextTick(function () {
            this.getExam().then((data) => {
              this.$store.commit('updateSelectedExercises', [])
              this.examExercises = this.exam.examExercises
              this.selectedGroup = 'NONE'
              this.reorderExercisesByGroup()
              this.setDefaultScoringSettings(postdata.exerciseVersionIds)
            })
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      selectGroup (group) {
        if (group) {
          this.selectedGroup = group
        }
      },
      reorderExercisesByGroup () {
        let tempExecGroup = ''
        let tempExecId = ''
        for (let i = 0; i < this.exam.examExercises.length; i++) {
          tempExecGroup = this.exam.examExercises[i].exerciseGroup
          tempExecId = this.exam.examExercises[i].exercise.exerciseId
          if (tempExecGroup === 'A') {
            if (!this.examExercisesByGroupID[0].includes(tempExecId)) {
              this.examExercisesByGroup[0].push(this.exam.examExercises[i])
              this.examExercisesByGroupID[0].push(tempExecId)
              continue
            } else {
              continue
            }
          } else if (tempExecGroup === 'B') {
            if (!this.examExercisesByGroupID[1].includes(tempExecId)) {
              this.examExercisesByGroup[1].push(this.exam.examExercises[i])
              this.examExercisesByGroupID[1].push(tempExecId)
              continue
            } else {
              continue
            }
          } else if (tempExecGroup === 'C') {
            if (!this.examExercisesByGroupID[2].includes(tempExecId)) {
              this.examExercisesByGroup[2].push(this.exam.examExercises[i])
              this.examExercisesByGroupID[2].push(tempExecId)
              continue
            } else {
              continue
            }
          } else {
            if (!this.examExercisesByGroupID[3].includes(tempExecId)) {
              this.examExercisesByGroup[3].push(this.exam.examExercises[i])
              this.examExercisesByGroupID[3].push(tempExecId)
              continue
            } else {
              continue
            }
          }
        }
      },
      setDefaultScoringSettings (addedExercises) {
        for (let i = 0; i < this.examExercises.length; i++) {
          if (addedExercises.includes(this.examExercises[i].exerciseVersionId)) {
            for (var prop in this.examExercises[i].scoringSettings) {
              // skip loop if the property is from prototype
              if (!this.examExercises[i].scoringSettings.hasOwnProperty(prop)) continue
              let tags = this.examExercises[i].exercise.data.tags
              this.examExercises[i].scoringSettings[prop].posPoints = 2
              // Set default scoring points if already specified in tags
              for (let tag of tags) {
                if (tag.startsWith('P') && tag.length === 2) {
                  this.examExercises[i].scoringSettings[prop].posPoints = parseInt(tag[1])
                }
                if (tag.startsWith('N') && tag.length === 2) {
                  this.examExercises[i].scoringSettings[prop].negPoints = parseInt(tag[1])
                  this.examExercises[i].scoringSettings[prop].allowNegativePointsSum = true
                }
              }
            }
            this.editExercise.push(this.examExercises[i])
          }
        }
        this.updateExercise()
      },
      removeRowExercise (exercise) {
        let forRemoval = [exercise]
        if (exercise.parent) {
          forRemoval = this.getAllExerciseVersions(exercise)
        }
        var vid = []
        forRemoval.forEach(ex => {
          vid.push(ex.exerciseVersionId)
        })
        var postdata = {
          exerciseVersionIds: vid
        }
        return Rest.request('DELETE', '/exams/' + this.exam.id + '/exercises', postdata).then((data) => {
          forRemoval.forEach(ex => {
            var ix = this.examExercises.indexOf(ex)
            this.examExercises.splice(ix, 1)
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      removeExerciseGroup (exercise) {
        let putdata = {
          exerciseVersionId: exercise.exerciseVersionId,
          exerciseGroup: exercise.exerciseGroup
        }
        let examExercisesByGroupCopy = this.examExercisesByGroup.splice()
        if (putdata.exerciseGroup === 'A') {
          this.examExercisesByGroup[0].splice(exercise, 1)
        } else if (putdata.exerciseGroup === 'B') {
          this.examExercisesByGroup[1].splice(exercise, 1)
        } else if (putdata.exerciseGroup === 'C') {
          this.examExercisesByGroup[2].splice(exercise, 1)
        } else {
          this.examExercisesByGroup[3].splice(exercise, 1)
        }
        return Rest.request('DELETE', '/exams/' + this.exam.id + '/exercises/group', putdata).then((data) => {
          this.$nextTick(function () {
            this.getExam().then((data) => {
              this.examExercises = this.exam.examExercises
              this.$store.commit('updateSelectedExercises', [])
              this.reorderExercisesByGroup()
            })
          })
        }).catch((err) => {
          console.log(err)
          this.examExercisesByGroup = examExercisesByGroupCopy
        })
      },
      updateExercise: async function () {
        let postdata = {
          exercises: []
        }
        while (this.editExercise.length > 0) {
          let exercisePost
          let exercise = this.editExercise.shift()
          if (this.exam.liveTest) {
            exercisePost = {
              examExerciseId: exercise.id,
              exGroup: exercise.exerciseGroup,
              scoringSettings: JSON.stringify(exercise.scoringSettings)
            }
          } else {
            exercisePost = {
              examExerciseId: exercise.id,
              scoringSettings: JSON.stringify(exercise.scoringSettings),
              exerciseSeconds: exercise.exerciseSeconds
            }
          }
          postdata.exercises.push(exercisePost)
        }
        Rest.request('PUT', '/exams/' + this.exam.id + '/exercises', postdata).then((data) => {
          this.updated = true
        }).catch((err) => {
          console.log(err)
        })
      },
      // class exam methods
      createClassExam (cl) {
        let postdata = {
          classId: cl.id
        }
        return Rest.request('POST', '/exams/' + this.exam.id + '/schedules/', postdata).then((data) => {
          this.$nextTick(function () {
            this.getExam().then((data) => {
              this.classExams = this.exam.classExams
            })
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      changePassModal (classExam) {
        this.editClassExam = classExam
        this.newPass = ''
        window.jQuery('#modal-edit').modal('toggle')
      },
      changePass () {
        if (this.newPass) {
          this.editClassExam.passwordRequired = true
        } else {
          this.editClassExam.passwordRequired = false
        }
        let putdata = {
          password: this.newPass
        }
        window.jQuery('#modal-edit').modal('toggle')
        this.updateClassExam(putdata)
      },
      changeDuration (classExam, index) {
        this.editClassExam = classExam
        let dur = 0
        if (this.selected[index] === this.$t('pages.exams.editExam.timeMinutes')) dur = classExam.duration * 60000
        else if (this.selected[index] === this.$t('pages.exams.editExam.timeHours')) dur = classExam.duration * 3600000
        else if (this.selected[index] === this.$t('pages.exams.editExam.timeDays')) dur = classExam.duration * 86400000
        this.newDuration = !this.newDuration
        this.newDuration2 = dur
      },
      publish (classExam, bool) {
        let date = null
        if (!classExam.startsAt || !classExam.finishesAt) {
          Rest.Vue.$snotify.error(this.$t('errors.missingInput') + this.$t('pages.exams.editExam.tableDateTime'), this.errorThrown)
          return
        } else if (!classExam.duration || classExam.duration === 0) {
          Rest.Vue.$snotify.error(this.$t('errors.missingInput') + this.$t('pages.exams.editExam.tableDuration'), this.errorThrown)
          return
        } else if (this.exam.liveTest && !classExam.classroom) {
          Rest.Vue.$snotify.error(this.$t('errors.missingInput') + this.$t('pages.exams.editExam.classRoom'), this.errorThrown)
          return
        }

        if (bool) date = moment()
        else date = null
        let putdata = {}
        if (this.isExam) {
          putdata = {
            publishedAt: date,
            exam: true
          }
        } else {
          putdata = {
            publishedAt: date,
            exam: false
          }
        }
        classExam.publishedAt = date
        this.editClassExam = classExam
        this.updateClassExam(putdata)
      },
      updateClassExam (putdata) {
        return Rest.request('PUT', '/exams/any/schedules/' + this.editClassExam.id, putdata).then((data) => {
          this.updated2 = true
          this.setPublished()
        }).catch((err) => {
          console.log(err)
        })
      },
      updateClassroom (classExam) {
        this.editClassExam = classExam
        let putdata = {
          exam: true,
          classroom: classExam.classroom
        }
        if (this.examId) {
          this.updateClassExam(putdata)
        }
      },
      addClassButton () {
        this.Search2 = !this.Search2
      },
      addRowClass () {
        var postdata = {
          classId: 1 // TODO
        }
        return Rest.request('POST', '/exams/' + this.exam.id + '/schedules', postdata).then((data) => {
          this.classExams.push(data)
        }).catch((err) => {
          console.log(err)
        })
      },
      removeRowClass (cls) {
        var vid = []
        vid.push(cls)
        return Rest.request('DELETE', '/exams/any/schedules/' + cls.id).then((data) => {
          var ix = this.classExams.indexOf(cls)
          this.classExams.splice(ix, 1)
        }).catch((err) => {
          console.log(err)
        })
      },
      toggleExercisesModal () {
        window.jQuery('#modal-exercises').modal('toggle')
      },
      checkLimit (toggle) {
        this.noLimit = toggle
        if (this.noLimit) {
          this.newRetries = 0
        } else {
          this.newRetries = this.exam.maxRetries
        }
      },
      toggleShowModal () {
        // if (ex) {
        //   this.getExercise(ex)
        //   console.log(this.celotnaNaloga)
        // }
        window.jQuery('#modal-show').modal('toggle')
      },
      openModal (exe) {
        this.$store.dispatch('updateModalForExercise', exe.exercise.exerciseId).then(() => {
          this.$store.commit('updateQuestionObject', {key: 'lngs', value: this.CelotnaNaloga.lngs})
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
          })
          window.jQuery('#modal-show').modal('toggle')
        })
      },
      getExercise (ex) {
        console.log(ex)
        this.$store.dispatch('updateModalForExercise', ex.exercise.id).then(() => {
          this.$store.commit('updateQuestionObject', {key: 'lngs', value: this.CelotnaNaloga.lngs})
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub])
          })
        })
      },
      selectAllSbgroupsInTree (id, value) {
        for (let i = 0; i < this.drevoPodskupin.length; i++) {
          if (this.drevoPodskupin[i].id === id) {
            let j = i + 1
            let nivo = this.drevoPodskupin[i].nivo
            while (j < this.drevoPodskupin.length && this.drevoPodskupin[j].nivo > nivo) {
              if (this.drevoPodskupin[j].list) {
                if (value) {
                  if (!this.izbranePodskupine.includes(this.drevoPodskupin[j].id)) {
                    this.izbranePodskupine.push(this.drevoPodskupin[j].id)
                  }
                } else {
                  let th = this
                  this.izbranePodskupine = this.izbranePodskupine.filter(function (el) {
                    return el !== th.drevoPodskupin[j].id
                  })
                }
              }
              j++
            }
            break
          }
        }
      },
      selectSubgroups () {
        this.loadingSubgroups = true
        this.drevoPodskupin = []
        window.jQuery('#selectSubgroupsModal').modal('toggle')
        Rest.request(`GET`, `/subgroups/` + this.gid + `/subgroupTree/root`).then((data) => {
          let tabela = []
          this.drevoVTabelo(tabela, data, 0)
          this.drevoPodskupin = tabela
          this.loadingSubgroups = false
          this.$nextTick(function () {
            window.MathJax.Hub.Queue(
              ['Typeset', window.MathJax.Hub]
            )
            /* var math = window.MathJax.Hub.getAllJax('exerciseStatList')[0]
            window.MathJax.Hub.Queue(['Text', math]) */
          })
        }).catch((err) => {
          console.log(err)
          this.loadingSubgroups = false
        })
      },
      drevoVTabelo (tabela, drevo, nivo) {
        tabela.push({
          name: drevo.name,
          id: drevo.id,
          nivo: nivo,
          list: drevo.subgroups.length === 0
        })
        for (let i = 0; i < drevo.subgroups.length; i++) {
          this.drevoVTabelo(tabela, drevo.subgroups[i], nivo + 1)
        }
      },
      addRatingExercises () {
        let postdata = {
          subgroupIds: this.izbranePodskupine,
          testDuration: this.izbranoTrajanje
        }
        Rest.request(`POST`, `/classExams/selectRatingExercises`, postdata).then((data) => {
          if (this.liveTest) {
            let postdata2 = {
              exerciseVersionIds: data.SelectedExercises,
              group: this.selectedGroup
            }
            return Rest.request('POST', '/exams/' + this.exam.id + '/exercises/group', postdata2).then((data) => {
              // window.jQuery('#modal-exercises').modal('toggle')
              this.$nextTick(function () {
                this.getExam().then((data) => {
                  this.$store.commit('updateSelectedExercises', [])
                  this.examExercises = this.exam.examExercises
                  this.selectedGroup = 'NONE'
                  this.reorderExercisesByGroup()
                  this.setDefaultScoringSettings(postdata2.exerciseVersionIds)
                })
              })
            }).catch((err) => {
              console.log(err)
            })
          } else {
            let postdata2 = {
              exerciseVersionIds: data.SelectedExercises
            }
            return Rest.request('POST', '/exams/' + this.exam.id + '/exercises/bulk', postdata2).then((data) => {
              this.$store.commit('updateSelectedExercises', [])
              this.$nextTick(function () {
                this.getExam().then((data) => {
                  this.examExercises = this.exam.examExercises
                  this.setDefaultScoringSettings(postdata2.exerciseVersionIds)
                })
              })
            }).catch((err) => {
              console.log(err)
            })
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    created () {
      this.getExam().then((data) => {
        if (this.exam.liveTest) {
          this.examExercises = this.exam.examExercises
          this.reorderExercisesByGroup()
          this.getClassrooms()
        } else {
          this.examExercises = this.exam.examExercises
        }
        this.classExams = this.exam.classExams
        if (this.exam.maxRetries === 0) {
          this.exam.maxRetries = 1
          this.noLimit = true
        }
        this.oneAtATime = this.exam['show_one_exercise']
        this.shuffle = this.exam['shuffle']
        this.getClasses()
        this.setPublished()
        this.formatTime()
        this.$store.commit('updateAdminBreadcrumbs', [{path: '', name: {'en-us': this.exam.title, sl: this.exam.title}}])
      }).catch((err) => {
        console.log(err)
      })
      this.$store.dispatch('getGroup', {
        gid: this.gid,
        yid: this.yid,
        sid: 'root'
      })
    },
    subscriptions () {
      return {
        // updating exam settings
        changeExamTitle: this.$watchAsObservable('newTitle').map((val) => val)
        .do({
          next: () => {
            this.updatedExam = false
          }
        })
        .debounceTime(1000)
        .distinctUntilChanged()
        .do({
          next: () => {
            let postdata = {
              title: this.newTitle
            }
            this.updateExam(postdata)
          }
        }),
        changeExamType: this.$watchAsObservable('newType').map((val) => val)
        .do({
          next: () => {
            this.getExam()
            this.updatedExam = false
          }
        })
        .debounceTime(1000)
        .distinctUntilChanged()
        .do({
          next: () => {
            let postdata = {}
            if (this.newType === 'exam') {
              postdata = {
                isExam: true,
                liveTest: false
              }
            } else if (this.newType === 'quiz') {
              postdata = {
                isExam: false,
                liveTest: false
              }
            } else {
              postdata = {
                isExam: false,
                liveTest: true
              }
            }
            this.updateExam(postdata).then((data) => {
              this.getExam()
            })
          }
        }),
        changeExamShowResult: this.$watchAsObservable('newShowResult').map((val) => val)
        .do({
          next: () => {
            this.updatedExam = false
          }
        })
        .debounceTime(1000)
        .distinctUntilChanged()
        .do({
          next: () => {
            let postdata = {
              showResult: this.newShowResult
            }
            this.updateExam(postdata)
          }
        }),
        changeExamRetries: this.$watchAsObservable('newRetries').map((val) => val.newValue)
        .do({
          next: () => {
            this.updatedExam = false
          }
        })
        .debounceTime(1000)
        .distinctUntilChanged()
        .do({
          next: () => {
            let postdata = {
              maxRetries: this.newRetries
            }
            this.updateExam(postdata)
          }
        }),
        newOneAtATime: this.$watchAsObservable('newOneAtATime').map((val) => val.newValue)
        .do({
          next: () => {
            this.updatedExam = false
          }
        })
        .debounceTime(1000)
        .distinctUntilChanged()
        .do({
          next: () => {
            let postdata = {
              'showOneExercise': this.newOneAtATime
            }
            this.updateExam(postdata)
          }
        }),
        newShuffle: this.$watchAsObservable('newShuffle').map((val) => val.newValue)
        .do({
          next: () => {
            this.updatedExam = false
          }
        })
        .debounceTime(1000)
        .distinctUntilChanged()
        .do({
          next: () => {
            let postdata = {
              'shuffle': this.newShuffle
            }
            this.updateExam(postdata)
          }
        }),
        // updating exam exercise setting
        changeExerciseAllow: this.$watchAsObservable('newAllow').map((val) => val.newValue)
        .do({
          next: () => {
            this.updated = false
          }
        })
        .debounceTime(500)
        .do({
          next: () => {
            this.updateExercise()
          }
        }),
        changeExamDuration: this.$watchAsObservable('newDuration').map((val) => val.newValue)
        .do({
          next: () => {
            this.updated2 = false
          }
        })
        .debounceTime(500)
        .do({
          next: () => {
            let postdata = {
              duration: this.newDuration2
            }
            this.updateClassExam(postdata)
          }
        })
      }
    }
  }
</script>

<style scoped>
tr[name="content"]:hover {
  cursor: move;
}

td[name="points"] {
  width: 3%;
}

td[name="tags"] {
  width: 12em;
}

input[name="retries"] {
  width: 3em;
  margin: auto;
  background: transparent;
  margin-left: 1em;
  border: 0.1em dotted #3c8dbc;
  border-left: none;
  border-right: none;
}

input[name="points2"] {
  width: 3em;
  margin: auto;
  background: transparent;
  margin-right: 0.3em;
  direction: rtl;

  border: none;
}

input[name="points3"] {
  width: 3em;
  margin: auto;
  background: transparent;
  border: 0.1em dotted #3c8dbc;
  border-top: none;
  border-left: none;
  border-right: none;
}

input[type="text"]
{
  background: transparent;
  border: 0.1em solid transparent;
}

input[name="title"]:hover {
  border: 0.1em solid #3c8dbc;
}

.grayout {
  opacity: 0.6;
  filter: alpha(opacity = 60);
  cursor: not-allowed;
  pointer-events:none;
}

.table-responsive {
  overflow-y: visible !important;
  overflow-x: visible;
}

select {
  background: transparent;
  border-left: none;
  border-right: none;
}

.allow {
  margin-left: 1em;
  padding: 0em;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
   opacity: 1;
}

.radio {
  display: inline-block;
  margin-left: 1.5em;
  margin-right: 1.5em;
}

.exerciseGroupsList {
  margin-top: 3em;
  margin-bottom: 3em;
  width: 100%;
}

.exerciseGroupsTitle {
  display: inline;
  float: left;
  margin-right: 1em;
  margin-left: 1em;
}

.exerciseGroupsAddButton {
  font-size: 10px;
  margin-top: 1em;
  border-radius: 2em;
  border: 2px solid black;
  background-color: white;
}

.exerciseGroupsAddButton:hover {
  background-color: black;
  color: white;
}

.groupCountInput {
  width: 20%;
}

td.date-range {
  width: 20em;
}

td.duration {
  width: 10em;
}

.picker {
  padding-left: 0;
  padding-top: 0;
}

</style>





// WEBPACK FOOTER //
// EditExam.vue?78d3e7b3